/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Length of the verification code Auth Extension sends by email or SMS. */
export const VERIFICATION_CODE_LENGTH = 6;

const VERIFICATION_CODE_REGEX = new RegExp(`^\\d{${VERIFICATION_CODE_LENGTH}}$`);

export type VerificationCodeError = 'empty' | 'invalidFormat';

/** Validates the code format before asking Commerce Cloud to check it. */
export function validateVerificationCode(code: string): VerificationCodeError | null {
    if (!code) {
        return 'empty';
    }
    return VERIFICATION_CODE_REGEX.test(code) ? null : 'invalidFormat';
}
